<div style="margin-top: 15%; margin-bottom: -100px; padding-bottom: 0">
  <img class="mx-auto d-block align-content-center" src="./assets/img/logo-loading.svg">
  <mat-spinner class="mx-auto" [diameter]="60" mode="indeterminate"></mat-spinner>
  <h5 class="text-center">Carregando...</h5>
</div>
